module.exports = __webpack_public_path__ + "static/media/DocBrowser_Brochure_2026.74c4b67d.pdf";